import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';

import { AdminCommonHttpService } from '../service/admin-common-http.service';
import { AdminAuthService } from '../service/admin-auth.service';
import { UsersDialogComponent } from './users-dialog/users-dialog.component';
import { MatDialog } from '@angular/material/dialog';

interface AdminUser {
  sub: string;
  email: string;
  full_name: string;
  is_active: boolean;
  tenant_id: string;
}

interface TenantUsersGroup {
  tenant_id: string;
  expanded: boolean;
  users: AdminUser[];
}

@Component({
  selector: 'app-manage-users',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule
  ],
  templateUrl: './manage-users.component.html',
  styleUrl: './manage-users.component.css'
})
export class ManageUsersComponent implements OnInit {

  displayedColumns = ['email', 'full_name', 'status', 'actions'];

  users: AdminUser[] = [];
  tenantGroups: TenantUsersGroup[] = [];

  isPlatformAdmin = false;
  loading = false;
  tenantIds: string[] = [];
  tenantId!: string;
  private dialog = inject(MatDialog);

  constructor(
    private http: AdminCommonHttpService,
    private auth: AdminAuthService
  ) { }

  async ngOnInit(): Promise<void> {
    this.isPlatformAdmin = await this.auth.isPlatformAdmin();
    this.loadUsers();

  }

  async loadUsers(): Promise<void> {
    this.loading = true;

    this.users = await this.http.getTenantUsers();
    if (this.isPlatformAdmin) {
      this.groupUsersByTenant();
      this.tenantIds = Array.from(new Set(this.users.map(u => u.tenant_id)));
    } else {
      this.tenantId = this.users.length > 0 ? this.users[0].tenant_id : '';
      console.log(`tenantId set to: ${this.tenantId}`);
    }
  }

  resendInvite(user: any) {
  }
  async toggleUser(user: any) {
    const payload = { sub: user.sub, full_name: user.full_name, incoming_tenant: user.tenant_id }
    user.is_active ? await this.http.disableUser(payload) : await this.http.enableUser(payload);
  }

  groupUsersByTenant(): void {
    const map = new Map<string, AdminUser[]>();

    for (const user of this.users) {
      if (!map.has(user.tenant_id)) {
        map.set(user.tenant_id, []);
      }
      map.get(user.tenant_id)!.push(user);
    }

    this.tenantGroups = Array.from(map.entries()).map(
      ([tenant_id, users]) => ({
        tenant_id,
        users,
        expanded: false
      })
    );
  }

  toggleTenant(group: TenantUsersGroup): void {
    group.expanded = !group.expanded;
  }

  statusLabel(user: AdminUser): string {
    return user.is_active ? 'Active' : 'Suspended';
  }

  statusClass(user: AdminUser): string {
    return user.is_active ? 'status-active' : 'status-suspended';
  }

  openInviteDialog() {
    console.log(`tenantIds: ${this.tenantIds}, tenantId: ${this.tenantId}`);
    const dialogRef = this.dialog.open(UsersDialogComponent, {
      width: '420px',
      data: {
        isPlatformAdmin: this.isPlatformAdmin,
        tenantOptions: this.tenantIds,
        currentTenantId: this.tenantId
      }
    });

    dialogRef.afterClosed().subscribe(payload => {
      if (!payload) return;
      this.inviteUser(payload);
    });
  }

  async inviteUser(payload: any) {
    const pl = {
      email: payload.email,
      full_name: payload.full_name,
      role: payload.role,
      incoming_tenant: payload.tenant_id
    }
    await this.http.inviteUser(pl).then(() => {
      this.loadUsers();
    });
  }
}
